<h2 mat-dialog-title>{{ title }}</h2>
<mat-dialog-content class="scope-content">
    <mat-radio-group class="scope-options" [(ngModel)]="scope" aria-label="Which events">
        <mat-radio-button *ngFor="let option of options" [value]="option.value">{{ option.label }}</mat-radio-button>
    </mat-radio-group>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancel</button>
    <button mat-flat-button [color]="data.action === 'delete' ? 'warn' : 'primary'" [mat-dialog-close]="scope">{{ data.action === 'delete' ? 'Delete' : 'Save' }}</button>
</mat-dialog-actions>
